import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // We'll add this for global styles
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: register notifications service worker for web push.
// This runs once on startup; UI can later call navigator.serviceWorker.ready
// to obtain a push subscription.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/notifications-sw.js')
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('Failed to register notifications service worker', err);
      });
  });
}
